require('slick-carousel');

$('.case-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: '<div class="slick-nav-arrow slick-nav-arrow-prev"> <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M2.41421 8L8.70711 14.2929C9.09763 14.6834 9.09763 15.3166 8.70711 15.7071C8.31658 16.0976 7.68342 16.0976 7.29289 15.7071L0.292894 8.70711C-0.0976302 8.31658 -0.0976302 7.68342 0.292894 7.29289L7.29289 0.292893C7.68342 -0.097631 8.31658 -0.0976309 8.70711 0.292893C9.09763 0.683418 9.09763 1.31658 8.70711 1.70711L2.41421 8Z" fill="#387BE0"/>\n' +
        '</svg></div>',
    nextArrow: '<div class="slick-nav-arrow slick-nav-arrow-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M2.41421 8L8.70711 14.2929C9.09763 14.6834 9.09763 15.3166 8.70711 15.7071C8.31658 16.0976 7.68342 16.0976 7.29289 15.7071L0.292894 8.70711C-0.0976302 8.31658 -0.0976302 7.68342 0.292894 7.29289L7.29289 0.292893C7.68342 -0.097631 8.31658 -0.0976309 8.70711 0.292893C9.09763 0.683418 9.09763 1.31658 8.70711 1.70711L2.41421 8Z" fill="#387BE0"/>\n' +
        '</svg></div>',
    centerMode: true,
    centerPadding: 30,
    responsive: [
        {breakpoint: 568, settings: {slidesToShow: 1}}
    ]
});
